exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.active[data-v-4fff495c] {\n  background: var(--primary-color) !important ;\n}\n", ""]);

// exports
